import React from 'react';
import { IconProps } from '../types';

export const Sprout: React.FC<IconProps> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 25.7143H28V23.4286H4V25.7143Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28 25.7143H4V9.054L16 2.28574L28 9.054V25.7143Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 7.5556V22.8493"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 13.143C16 10.6161 18.0446 8.57155 20.5714 8.57155C20.5714 11.0984 18.5269 13.143 16 13.143Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 20.0001C16 17.4732 18.0446 15.4286 20.5714 15.4286C20.5714 17.9555 18.5269 20.0001 16 20.0001Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4281 12.0001C13.955 12.0001 15.9995 14.0447 15.9995 16.5716C13.4727 16.5716 11.4281 14.527 11.4281 12.0001Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
